import React, { JSX } from 'react';
import { View } from './View';
import { TabOpenButton } from './TabOpenButton';
import { openButton } from './multiple-tabs/OpenButton';
import { open } from './multiple-tabs/open';
import {
  darkPdfViewerTheme,
  lightPdfViewerTheme,
  generateStylesFromTheme,
  type PdfViewerTheme,
} from './themes';
import type {
  ViewProps,
  TabOpenButtonProps,
  MultipleTabsOpenButtonProps,
  ViewType,
  ViewConfig,
  DetailItem,
  ViewDetailItem,
} from './types';

export interface PdfComponent {
  <T extends ViewProps>(props: T): JSX.Element;
  TabOpenButton: React.FC<TabOpenButtonProps>;
  OpenMultipleButton: React.FC<MultipleTabsOpenButtonProps>;
  openMultiple: (pdfItems: ViewType[], config?: ViewConfig) => void;
  themes: {
    dark: PdfViewerTheme;
    light: PdfViewerTheme;
    generateStyles: (theme: PdfViewerTheme) => string;
  };
}

const _Pdf = View as unknown as PdfComponent;
_Pdf.TabOpenButton = TabOpenButton;
_Pdf.OpenMultipleButton = openButton;
_Pdf.openMultiple = open;
_Pdf.themes = {
  dark: darkPdfViewerTheme,
  light: lightPdfViewerTheme,
  generateStyles: generateStylesFromTheme,
};

export const Pdf = _Pdf;

export namespace Pdf {
  type ViewPropsType = import('./types').ViewProps;
  type TabOpenButtonPropsType = import('./types').TabOpenButtonProps;
  type MultipleTabsOpenButtonPropsType =
    import('./types').MultipleTabsOpenButtonProps;
  type ViewTypeType = import('./types').ViewType;
  type ViewConfigType = import('./types').ViewConfig;
  type DetailItemType = import('./types').DetailItem;
  type ViewDetailItemType = import('./types').ViewDetailItem;
  type PdfViewerThemeType = import('./themes').PdfViewerTheme;

  export type ViewProps = ViewPropsType;
  export type TabOpenButtonProps = TabOpenButtonPropsType;
  export type MultipleTabsOpenButtonProps = MultipleTabsOpenButtonPropsType;
  export type ViewType = ViewTypeType;
  export type ViewConfig = ViewConfigType;
  export type DetailItem = DetailItemType;
  export type ViewDetailItem = ViewDetailItemType;
  export type PdfViewerTheme = PdfViewerThemeType;
}
